<template>
    <div class="popFixed" v-if="isCutOver">
        <div class="masking" @click="closePop"></div>
        <div class="tcCon">
            <div class="item">
                <span>{{$t("message.point")}}</span>
                <p>{{errMessage}}</p>
            </div>
            <div class="btnCon only">
                <span @click="closePop">{{$t("message.definite")}}</span>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: "CutOverPop",
        props:["errMessage"],
        data(){
            return{
                isCutOver:false
            }
        },
        methods:{
            closePop(){
                this.isCutOver=!this.isCutOver
            }
        }
    }
</script>
